/**
 * Returns a numeric representation of a browser or os version.
 *
 * I.e. 11.2.25.20220715 => 11.2
 */
export function parseMajorMinorVersion(version?: string): number {
  if (!version) return -1;
  const [major, minor] = version.split('.');
  return Number([major, minor].filter(Boolean).join('.'));
}
